import { Button, Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { estadoCivilKeyToLabel } from "../../../detalhes-do-projeto/filtros/estado-civil"
// Icon
import DeleteIcon from '@mui/icons-material/Delete'
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle'

export const RecorteEstadoCivilFilterPreview = () => {
    // State
    const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Hook
    const { removeEditRecorteFormFiltros } = useRecortesExtracaoService()

    const hasEstadoCivil = editRecorteExtracaoForm.fields.Filtros?.estadoCivil &&
        editRecorteExtracaoForm.fields.Filtros.estadoCivil.length > 0;

    const handleRemoveFilter = () => {
        removeEditRecorteFormFiltros({ filtro: 'estadoCivil' });
    };

    if (!hasEstadoCivil) {
        return null;
    }

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Estado Civil
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="outlined"
                                startIcon={<DeleteIcon />}
                                onClick={handleRemoveFilter}
                            >
                                Remover filtro
                            </Button>
                        </Grid>
                    </Grid>

                    {editRecorteExtracaoForm.fields.Filtros &&
                        editRecorteExtracaoForm.fields.Filtros.estadoCivil && (
                            <Grid item xs={12}>
                                <Stack
                                    direction="row"
                                    flexWrap="wrap"
                                >
                                    {editRecorteExtracaoForm.fields.Filtros.estadoCivil.map((estadoCivil, i) => (
                                        <Chip
                                            key={i}
                                            icon={<SupervisedUserCircleIcon />}
                                            label={estadoCivilKeyToLabel(estadoCivil).toUpperCase()}
                                            sx={{
                                                m: 0.5
                                            }}
                                        />
                                    ))}
                                </Stack>
                            </Grid>
                        )}
                </Paper>
            </Grid>
        </>
    )
}